import React, {useState} from "react";
import {Alert, Button, Col, Modal, Row, Well} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSync} from "@fortawesome/free-solid-svg-icons";
import MDSpinner from "react-md-spinner";
import Dollars from "../../../../components/Dollars";
import moment from "moment";
import {defaultDateTimeFormat} from "../../../../common/commonHandlers";

const SyncTransactionsModal = ({onHide, getTransactionsFromStripe, reload}) => {
    const [afterSync, setAfterSync] = useState(false)
    const [loading, setLoading] = useState(false)
    const [newTransactions, setNewTransactions] = useState([])
    const [error, setError] = useState(null)

    const confirmationRow = () => {
        return <Row className="text-center">
            <Col xs={12}><h4>Are you sure you want to sync new transactions now? This may take a while.</h4></Col>
            <Col xs={12}>
                <Button
                    bsStyle="success"
                    className="ml-7 mt-5"
                    onClick={() => {
                        setError(null)
                        setLoading(true)
                        getTransactionsFromStripe((res) => {
                            setNewTransactions(res)
                            setLoading(false)
                            setAfterSync(true)
                        }, (res) => {
                            setError(res?.data?.message)
                            setLoading(false)
                        })
                    }}
                >
                    Sync now <FontAwesomeIcon icon={faSync} className="ml-7"/>
                </Button>
            </Col>
        </Row>
    }

    const newTransactionsRow = () => {
        const valueFormatter = (transaction) => {
            const amount = transaction.amount/100
            const fee = transaction.fee/100
            const net = transaction.net/100
            const valueColorStyle = (value) => value > 0 ? 'green' : value === 0 ? null : 'red';

            return <Row className="text-left">
                <Col xs={12}>
                    <span className="mr-3">Amount:</span>
                    <span style={{color: valueColorStyle(amount)}}><b><Dollars amount={amount}/></b></span>
                </Col>
                <Col xs={12}>
                    <span className="mr-3">Fee:</span>
                    <span style={{color: valueColorStyle(fee)}}><b><Dollars amount={fee}/></b></span>
                </Col>
                <Col xs={12}>
                    <span className="mr-3">Net:</span>
                    <span style={{color: valueColorStyle(net)}}><b><Dollars amount={net}/></b></span>
                </Col>
            </Row>
        };

        const currencyFormatter = (transaction) => transaction ? transaction.toUpperCase() : <span>N/A</span>
        const dateFormat = (date) => moment.unix(date).format(defaultDateTimeFormat)

        return <Row>
            {newTransactions && newTransactions.length > 0 ?
                <Col xs={12}>
                    <Row><Alert bsStyle="success"><h4 className="no-margin">Found {newTransactions.length} New Transactions:</h4></Alert></Row>
                    {newTransactions.map((t, i) => {
                        const details = JSON.parse(t.fee_details)
                        return <Row className="text-left padding-top-10">
                            {i !== 0 && <hr/>}
                            <Col xs={12}>{valueFormatter(t)}</Col>
                            <Col xs={12} className="d-flex">
                                <div className="mr-3" style={{textWrap: 'nowrap'}}>Currency:</div>
                                <div className="bold">{currencyFormatter(t.currency)}</div>
                            </Col>
                            <Col xs={12} className="d-flex">
                                <div className="mr-3" style={{textWrap: 'nowrap'}}>Created:</div>
                                <div className="bold">{dateFormat(t.created)}</div>
                            </Col>
                            <Col xs={12} className="d-flex">
                                <div className="mr-3" style={{textWrap: 'nowrap'}}>Available On:</div>
                                <div className="bold">{dateFormat(t.available_on)}</div>
                            </Col>
                            <Col xs={12} className="d-flex">
                                <div className="mr-3" style={{textWrap: 'nowrap'}}>Exchange Rate:</div>
                                <div className="bold">{t.exchange_rate ? t.exchange_rate : <span>N/A</span>}</div>
                            </Col>
                            <Col xs={12} className="d-flex">
                                <div className="mr-3" style={{textWrap: 'nowrap'}}>Transaction Type:</div>
                                <div className="bold">{t.stripe_transaction_type ? t.stripe_transaction_type : <span>N/A</span>}</div>
                            </Col>
                            <Col xs={12} className="d-flex">
                                <div className="mr-3" style={{textWrap: 'nowrap'}}>Status:</div>
                                <div className="bold">{t.status ? t.status : <span>N/A</span>}</div>
                            </Col>
                            <Col xs={12} className="d-flex">
                                <div className="mr-3" style={{textWrap: 'nowrap'}}>Object:</div>
                                <div className="bold">{t.object ? t.object : <span>N/A</span>}</div>
                            </Col>
                            <Col xs={12} className="d-flex">
                                <div className="mr-3" style={{textWrap: 'nowrap'}}>Reporting Category:</div>
                                <div className="bold">{t.reporting_category ? t.reporting_category : <span>N/A</span>}</div>
                            </Col>
                            <Col xs={12} className="d-flex">
                                <div className="mr-3" style={{textWrap: 'nowrap'}}>Invoice:</div>
                                <div className="bold">{t.invoice_no ? `#${t.invoice_no}` : <span>N/A</span>}</div>
                            </Col>
                            <Col xs={12} className="d-flex">
                                <div className="mr-3" style={{textWrap: 'nowrap'}}>Customer:</div>
                                <div className="bold">{t.customer_name ? `#${t.customer_name}` : <span>N/A</span>}</div>
                            </Col>
                            <Col xs={12} className="d-flex">
                                <div className="mr-3" style={{textWrap: 'nowrap'}}>Client:</div>
                                <div className="bold">{t.client_name ? t.client_name : <span>N/A</span>}</div>
                            </Col>
                            <Col xs={12} className="d-flex">
                                <div className="mr-3" style={{textWrap: 'nowrap'}}>Stripe ID:</div>
                                <div className="bold">{t.stripe_id ? t.stripe_id : <span>N/A</span>}</div>
                            </Col>
                            <Col xs={12} className="d-flex">
                                <div className="mr-3" style={{textWrap: 'nowrap'}}>Source ID:</div>
                                <div className="bold">{t.source ? t.source : <span>N/A</span>}</div>
                            </Col>
                            <Col xs={12} className="d-flex">
                                <div className="mr-3" style={{textWrap: 'nowrap'}}>Description:</div>
                                <div className="bold">{t.description ? t.description : <span>N/A</span>}</div>
                            </Col>
                            <Col xs={12}>
                                {details && details.length > 0 ?
                                    <Row>
                                        <Col xs={12} className="mr-3">Fee Details:</Col>
                                        <Col xs={12} style={{paddingLeft: '50px'}}>
                                            {details.map(detail => <>
                                                <Row className="d-flex">
                                                    <div className="mr-5" style={{textWrap: 'nowrap'}}>Amount:</div>
                                                    <div className="bold"><Dollars amount={detail.amount}/></div>
                                                </Row>
                                                <Row className="d-flex">
                                                    <div className="mr-5" style={{textWrap: 'nowrap'}}>Application:</div>
                                                    <div className="bold">{detail.application ? detail.application : <span>N/A</span>}</div>
                                                </Row>
                                                <Row className="d-flex">
                                                    <div className="mr-5" style={{textWrap: 'nowrap'}}>Currency:</div>
                                                    <div className="bold">{currencyFormatter(detail.currency)}</div>
                                                </Row>
                                                <Row className="d-flex">
                                                    <div className="mr-5" style={{textWrap: 'nowrap'}}>Description:</div>
                                                    <div className="bold">{detail.description}</div>
                                                </Row>
                                                <Row className="d-flex">
                                                    <div className="mr-5" style={{textWrap: 'nowrap'}}>Type:</div>
                                                    <div className="bold">{detail.type}</div>
                                                </Row>
                                            </>)}
                                        </Col>
                                    </Row>
                                    :
                                    <Row>
                                        <Col xs={12} className="d-flex">
                                            <div className="mr-3" style={{textWrap: 'nowrap'}}>Fee Details:</div>
                                            <div className="bold"><span>N/A</span></div>
                                        </Col>
                                    </Row>
                                }

                            </Col>
                        </Row>
                    })}
                </Col>
                :
                <Col xs={12}><Alert bsStyle="success"><h4 className="no-margin">Transactions are up to date</h4></Alert></Col>
            }
        </Row>
    }

    return <Modal
        show={true}
        onHide={onHide}
        backdrop={false}
        className={"heightAuto maxHeight90 modalLeadsFilterBody fontIOS"}
    >
        <Modal.Header>
            <Modal.Title>Get new Transactions</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{maxHeight: '500px', overflow: 'auto', padding: '0 !important'}}>
            <Well bsSize="large" className="align-center no-margin">
                {error && <Alert bsStyle="danger"><h4 className="no-margin">Error: {error.toString()}</h4></Alert>}
                {afterSync || loading ?
                    afterSync ?
                        newTransactionsRow()
                        :
                        <div className='vhCenter mb-15'>
                            <MDSpinner size={70} borderSize={2}/>
                        </div>
                    :
                    confirmationRow()
                }
            </Well>
        </Modal.Body>
        <Modal.Footer>
            <Button
                bsStyle="success"
                className="ml-7 mt-5"
                disabled={loading}
                onClick={() => {
                    if (newTransactions && newTransactions.length > 0) {
                        reload()
                        onHide()
                    } else {
                        onHide()
                    }
                }}
            >
                Close
            </Button>
        </Modal.Footer>
    </Modal>
}

export default SyncTransactionsModal;